import PropTypes from 'prop-types'
import Lottie from 'react-lottie-player'

import MatrixIndicator from '../../assets/animations/matrix-indicator.json'
import { useAivyContext, useLanguageContext } from '../../context'
import { classNames } from '../../helpers'

const getPointPosition = ({
  HEROS_JOURNEY_score_coopcomp,
  HEROS_JOURNEY_score_orderchaos
}) => {
  if (
    HEROS_JOURNEY_score_coopcomp === 0 &&
    HEROS_JOURNEY_score_orderchaos === 0
  ) {
    return { left: '20%', top: '72%' }
  }

  if (
    HEROS_JOURNEY_score_coopcomp === 0 &&
    HEROS_JOURNEY_score_orderchaos === 100
  ) {
    return { left: '20%', top: '20%' }
  }

  if (
    HEROS_JOURNEY_score_coopcomp === 100 &&
    HEROS_JOURNEY_score_orderchaos === 0
  ) {
    return { left: '72%', top: '72%' }
  }

  if (
    HEROS_JOURNEY_score_coopcomp === 100 &&
    HEROS_JOURNEY_score_orderchaos === 100
  ) {
    return { left: '72%', top: '20%' }
  }
}

const HerosJourneyMatrix = ({
  className,
  culturalFitValues,
  // Die Achsen-Labels sitzen absolut auf left-0/right-0 und ragen nach innen.
  // Bei kompakten Breiten kollidieren sie in der Mitte - dann text-xs setzen.
  labelClassName = 'text-sm'
}) => {
  const { language } = useLanguageContext()
  const {
    system: { dimensions_pdf_reports }
  } = useAivyContext()

  const { scaleEndpoints: scaleEndpointsCoopcomp } =
    dimensions_pdf_reports.HEROS_JOURNEY_score_coopcomp

  const { scaleEndpoints: scaleEndpointsOrderchaos } =
    dimensions_pdf_reports.HEROS_JOURNEY_score_orderchaos

  const { x, y } = {
    x: {
      minus: scaleEndpointsCoopcomp.left.title[language],
      plus: scaleEndpointsCoopcomp.right.title[language]
    },
    y: {
      minus: scaleEndpointsOrderchaos.left.title[language],
      plus: scaleEndpointsOrderchaos.right.title[language]
    }
  }

  const pointPosition = getPointPosition(culturalFitValues)

  return (
    <div className={classNames('relative', className)}>
      {/* y-axis */}
      <div
        style={{ background: '#B6C7F2' }}
        className='absolute bottom-0 left-1/2 top-0 w-0.5 -translate-x-1/2 transform'
      />

      {/* x-axis */}
      <div
        style={{ background: '#B6C7F2' }}
        className='absolute left-0 right-0 top-1/2 h-0.5 -translate-y-1/2 transform'
      />

      <span
        className={classNames(
          'absolute -bottom-1 left-1/2 -mb-4 -translate-x-1/2 transform text-gray-700',
          labelClassName
        )}
      >
        {y.minus}
      </span>
      <span
        className={classNames(
          'absolute -top-1 left-1/2 -mt-4 -translate-x-1/2 transform text-gray-700',
          labelClassName
        )}
      >
        {y.plus}
      </span>

      <span
        className={classNames(
          'absolute right-0 top-1/2 translate-y-1 transform text-gray-700',
          labelClassName
        )}
      >
        {x.plus}
      </span>
      <span
        className={classNames(
          'absolute left-0 top-1/2 translate-y-1 transform text-gray-700',
          labelClassName
        )}
      >
        {x.minus}
      </span>

      <div className='flex w-full justify-center'></div>

      <div className='absolute' style={pointPosition}>
        <Lottie
          style={{ width: 32, height: 32 }}
          animationData={MatrixIndicator}
          play
          loop
        />
      </div>
    </div>
  )
}

HerosJourneyMatrix.propTypes = {
  className: PropTypes.string,
  culturalFitValues: PropTypes.object.isRequired,
  labelClassName: PropTypes.string
}

export default HerosJourneyMatrix
